import React from 'react'

import PartialCTA from './partials/cta'

const PartnerLinks = ({ block }) => (
  <section className={`block ${block._template} ${block.css_class_name}`}>
    <div className="container">
      <ul className='items'>
        {block.items.map((item, index) => {
          return <li key={index}>
            {item.image && (
              <img src={item.image} alt={item.image_alt_text} title={item.image_alt_text} />
            )}
            {item.name && ( <h3 dangerouslySetInnerHTML={{__html: item.name}}></h3> )}
            {item.cta_field && ( <PartialCTA data={item.cta_field} /> )}
          </li>
        })}
      </ul>
    </div>
  </section>
)

export default PartnerLinks
